var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('sectionEdit',{attrs:{"canEditShop":this.canCreateShops,"id":this.id},on:{"section-update-completed":_vm.goBack,"section-update-canceled":_vm.goBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }